module.exports = __webpack_public_path__ + "static/img/banner.b9e53cd.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/qipai/banner.webp
// module id = 7JkZ
// module chunks = 3